"use client"

import * as React from "react"
import * as SwitchPrimitive from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "cy:peer cy:data-[state=checked]:bg-primary cy:data-[state=unchecked]:bg-input cy:focus-visible:border-ring cy:focus-visible:ring-ring/50 cy:dark:data-[state=unchecked]:bg-input/80 cy:inline-flex cy:h-[28px] cy:w-[56px] cy:shrink-0 cy:items-center cy:rounded-full cy:border cy:border-transparent cy:shadow-xs cy:transition-all cy:outline-none cy:focus-visible:ring-[3px] cy:disabled:cursor-not-allowed cy:disabled:opacity-50",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "cy:bg-background cy:dark:data-[state=unchecked]:bg-foreground cy:dark:data-[state=checked]:bg-primary-foreground cy:pointer-events-none cy:block cy:size-5.5 cy:rounded-full cy:ring-0 cy:transition-transform cy:data-[state=checked]:translate-x-[28px] cy:data-[state=unchecked]:translate-x-1"
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
